import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (id, body) {
  const { data, error, status } = await useApiFetch(API_ENDPOINTS.ESHOP_PRODUCT_WATCHDOG_ID, {
    method: 'PUT',
    path: { id },
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'product-watchdog-update',
      level: 'error',
      extra: { error: error.value }
    });

    return null;
  }

  return data.value;
}
